// extracted by mini-css-extract-plugin
export default {"card":"NotificationGridComponentCard_card__XS0x9","tooltip":"NotificationGridComponentCard_tooltip__AXgzH","name":"NotificationGridComponentCard_name__J3zYs"};